import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { to64decode } from 'src/app/helpers/base64';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { getLanguageCookie } from 'src/assets/language';
import { codeDataArray, extendedAttributeArray } from 'src/assets/const/codeDataArray';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { v4 } from 'uuid';
@Component({
  selector: 'app-code-data',
  templateUrl: './code-data.component.html',
  styleUrls: ['./code-data.component.scss']
})
export class CodeDataComponent {

  searchContent: string = ''
  searchText: string = '';
  dataSource: any;
  filteredDatasource: any;
  currentPage = 1;
  itemsPerPage = 10;

  selectedTypeCodeData: any = {
    label: '',
    uuid: ''
  }
  searchTypeCodeData: string = '';
  codeDataArray: any = codeDataArray
  isLoading: boolean = true;
  displayedColumns: string[] = ['Name', 'Action'];
  extendedAttributeArray: any = extendedAttributeArray

  constructor(
    private corporationService: CorporationService,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.filteredDatasource = new MatTableDataSource([]);
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  searchProfiles() {
    const searchText = this.searchText.toLowerCase()
    this.filteredDatasource.data = this.dataSource.data.filter((item: { name: any; }) => item.name.toLowerCase().includes(searchText));
  }

  getName(label: any) {
    const language = to64decode(localStorage.getItem('language'))?.lang;
    if (language && label[language]) {
      return label[language];
    }
    return label['pt'];
  }

  getExtendedAttribute(type: string) {
    return this.extendedAttributeArray.find((item: any) => item.slug === type);
  }

  getData() {
    this.isLoading = true;
    this.getCodeDataArray(this.selectedTypeCodeData.slug);
  }

  choseItemSelect(item: any) {
    this.selectedTypeCodeData = item;
    this.getData();
  }

  choseItemSelectTypeExtendedAttribute(item: any, row: any) {
    row.type = item.slug
  }

  save() {
    const newRows = this.dataSource.data.filter((item: any) => item.name == 'New +' || item.name == 'new +' || item.name == 'New+' || item.name == 'new+');

    if (newRows.length > 0) {
      addAlert('orange', this.getLanguages('code_data/newPlus'));
      return;
    }

    this.dataSource.data = this.dataSource.data.filter((item: any) => item.name !== '' && item.name !== null);
    this.filteredDatasource.data = this.dataSource.data
    this.setCodeDataArray(this.selectedTypeCodeData.slug);
  }

  choseItemsPage(number: number) {
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredDatasource.data.slice(startIndex, endIndex);
  }

  getTotalPages() {
    return Math.ceil(this.filteredDatasource.data.length / this.itemsPerPage);
  }

  async checkValue(event: any) {
    let total = this.getTotalPages()

    if (this.currentPage > total) {
      this.currentPage = total;
    }
  }

  getItemsPerPage() {
    return this.itemsPerPage
  }

  getCurrentPages(): number {
    return this.currentPage
  }

  newRow() {
    this.searchText = '';
    this.dataSource.data.push({
      uuid: v4(),
      name: ''
    })
    this.filteredDatasource.data = this.dataSource.data

  }

  deleteRow(uuid: string) {
    this.dataSource.data = this.dataSource.data.filter((item: any) => item.uuid !== uuid);
    this.filteredDatasource.data = this.dataSource.data
  }

  async setCodeDataArray(path: string) {
    if(this.selectedTypeCodeData.slug === 'corporations-extended-attribute') {
      this.dataSource.data = this.dataSource.data.map((item: any) => {
        if(item.type === 'restricted-text') {
          item.values = item.values.split(';');
        }
        return item;
      });
    }
    try {
      const response: any = await this.corporationService.setCodeDataArray({ data: this.dataSource.data }, path);
      if (response.data && (response.status == 200 || response.status == 201)) {
        addAlert('success', this.getLanguages('code_data/success'));
        this.getData();
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getCodeDataArray(path: string) {
    try {
      const response: any = await this.corporationService.getCodeDataArray(path);
      if (response.data && (response.status == 200 || response.status == 201)) {
        this.dataSource.data = response.data;
        this.filteredDatasource.data = response.data;

        this.dataSource.data = this.dataSource.data.map((item: any) => {
          if (path === 'corporations-extended-attribute') {
            return {
              uuid: item.uuid,
              name: item.name,
              type: item?.type,
              values: Array.isArray(item?.values) 
                ? item.values.map((value: string) => value.trim()).join('; ')
                : (item?.values || '').split(',').map((value: string) => value.trim()).join('; ') // o values vem assim: item1, item2, item3 preciso que venha item1; item2; item3
            };
          }
          return {
            uuid: item.uuid,
            name: item.name
          };
        });
        this.filteredDatasource.data = this.dataSource.data;
        this.isLoading = false;
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  autoResize(event: Event, row?: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');

    if (!tr) {
      return;
    }

    const textareas = tr.querySelectorAll('textarea');
    let maxHeight = 0;

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = 'auto';
      const taHeight = ta.scrollHeight;
      if (taHeight > maxHeight) {
        maxHeight = taHeight;
      }
    });

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = `${maxHeight}px`;
    });
  }
}
